import formInputsTypes from '../simulatorConstant';

const forfaitsData = [
	{
		id: 11,
		label: 'Forfait déblocage de store banne',
		value: 'Forfait déblocage de store banne',
		description:
			'*Forfait déblocage de store banne :\n' +
			'- Diagnostic de l’origine du blocage du store banne\n' +
			'- Déblocage manuel du mécanisme\n' +
			'- Vérification du bon fonctionnement ouverture / fermeture\n' +
			'- Remise en état et sécurisation du store après intervention\n',
		lst_price: 220,
		isInline: true,
	},

	{
		id: 13,
		label: 'Forfait dépose et repose de store banne',
		value: 'Forfait dépose et repose de store banne',
		description:
			'*Forfait dépose et repose de store banne :\n' +
			'- Dépose complète du store banne existant\n' +
			'- Intervention sur le support ou l’environnement si nécessaire\n' +
			'- Repose du store banne dans les règles de l’art\n' +
			'- Réglages et tests de bon fonctionnement\n',
		lst_price: 300,
		isInline: true,
	},

	{
		id: 14,
		label: 'Forfait dépose de store banne',
		value: 'Forfait dépose de store banne',
		description:
			'*Forfait dépose de store banne :\n' +
			'- Dépose sécurisée du store banne existant\n' +
			'- Désolidarisation des fixations murales ou supports\n' +
			'- Mise en sécurité du store après dépose\n',
		lst_price: 150,
		isInline: true,
	},

	{
		id: 15,
		label: 'Forfait pose de store banne',
		value: 'Forfait pose de store banne',
		description:
			'*Forfait pose de store banne :\n' +
			'- Pose du store banne sur supports existants ou préparés\n' +
			'- Fixation et mise à niveau du store\n' +
			'- Réglage des bras et de l’inclinaison\n' +
			'- Tests de bon fonctionnement ouverture / fermeture\n',
		lst_price: 150,
		isInline: true,
	},

	{
		id: 16,
		label: 'Forfait remplacement d’une ficelle de store',
		value: 'Forfait remplacement d’une ficelle de store',
		description:
			'*Forfait remplacement d’une ficelle de store :\n' +
			'- Dépose de la ficelle usée ou rompue\n' +
			'- Fourniture et pose d’une ficelle neuve compatible\n' +
			'- Réglage de la tension et du mécanisme\n' +
			'- Essais de fonctionnement du store\n',
		lst_price: 260,
		isInline: true,
	},
];

const forfaitsStore = {
	id: 'ForfaitsSM',
	type: formInputsTypes?.CHECKBOX_INPUT,
	label: 'Forfaits',
	name: 'ForfaitsSM',
	className: 'col-12',
	classGroup: 'simulator-check',
	options: forfaitsData,
};

export default forfaitsStore;
